import { initCaptivePortal, addCaptivePortal, updateCaptivePortal, deleteCaptivePortal } from 'stores/slice/bogus/captivePortal/const';
import { setMacAddressesData } from 'stores/slice/bogus/profiles/macAddress/const';

const captivePortalConfig = {
  '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals.read': {
    protocol: 'ws',
    resource: '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'read',
    buildParams: null,
    action: initCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/orgs/:orgId/sites/:siteId/settings/captivePortals.read': {
    protocol: 'ws',
    resource: '/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'read',
    buildParams: null,
    action: initCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals.create': {
    protocol: 'ws',
    resource: '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'create',
    buildParams: params => ({ data: params }),
    action: addCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/orgs/:orgId/sites/:siteId/settings/captivePortals.create': {
    protocol: 'ws',
    resource: '/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'create',
    buildParams: params => ({ data: params }),
    action: addCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals/:captivePortalId.update': {
    protocol: 'ws',
    resource: '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals/:captivePortalId',
    restful: true,
    method: 'update',
    buildParams: params => ({ data: params }),
    action: updateCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/orgs/:orgId/sites/:siteId/settings/captivePortals/:captivePortalId.update': {
    protocol: 'ws',
    resource: '/orgs/:orgId/sites/:siteId/settings/captivePortals/:captivePortalId',
    restful: true,
    method: 'update',
    buildParams: params => ({ data: params }),
    action: updateCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals.delete': {
    protocol: 'ws',
    resource: '/ents/:entId/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'delete',
    buildParams: params => ({ data: params }),
    action: deleteCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/orgs/:orgId/sites/:siteId/settings/captivePortals.delete': {
    protocol: 'ws',
    resource: '/orgs/:orgId/sites/:siteId/settings/captivePortals',
    restful: true,
    method: 'delete',
    buildParams: params => ({ data: params }),
    action: deleteCaptivePortal,
    mockSelector: 'captivePortal',
  },
  '/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.read': {
    protocol: 'ws',
    resource: '/ents/:entId/orgs/:orgId/sites/:siteId/settings/profileMacAddrs',
    restful: true,
    method: 'read',
    buildParams: null,
    action: setMacAddressesData,
    mockSelector: 'captivePortal',
  },
  '/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.read': {
    protocol: 'ws',
    resource: '/orgs/:orgId/sites/:siteId/settings/profileMacAddrs',
    restful: true,
    method: 'read',
    buildParams: null,
    action: setMacAddressesData,
    mockSelector: 'captivePortal',
  },
};

export default captivePortalConfig;
